export default function capitalize([firstLetter, ...rest]) {
	if(!firstLetter) { return '' }
	return [firstLetter.toLocaleUpperCase(), ...rest].join('')
}